import { render, staticRenderFns } from "./DetailBatch.vue?vue&type=template&id=b8907512"
import script from "./DetailBatch.vue?vue&type=script&lang=js"
export * from "./DetailBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports